"use client";

import React from "react";
import Link from "next/link";
import { useIsAdLanding } from "@/lib/hooks/useIsAdLanding";
import { NewButton } from "@/components/ui/NewButton";

type CtaButton = {
  text: string;
  href: string;
  variant: "accent" | "outlineAccent";
  arrow?: "grow";
};


export function FinalGradientCTAButtons({
  primaryButton,
  secondaryButton,
}: {
  primaryButton: CtaButton;
  secondaryButton?: CtaButton;
}) {
  const isAdLanding = useIsAdLanding();

  if (isAdLanding) {
    return (
      <div className="flex flex-wrap gap-4 justify-center">
        <Link href="/book-a-demo" data-mixpanel-id="final-cta-book-a-demo-utm">
          <NewButton variant="accent" size="md" arrow="grow">
            Book a Demo
          </NewButton>
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-4 justify-center">
      <Link href={primaryButton.href} data-mixpanel-id="final-cta-primary">
        <NewButton variant={primaryButton.variant} size="md" arrow={primaryButton.arrow}>
          {primaryButton.text}
        </NewButton>
      </Link>
      {secondaryButton ? (
        <Link href={secondaryButton.href} data-mixpanel-id="final-cta-secondary">
          <NewButton variant={secondaryButton.variant} size="md">
            {secondaryButton.text}
          </NewButton>
        </Link>
      ) : null}
    </div>
  );
}

